module.exports = __webpack_public_path__ + "img/w25-b2.68553313.jpg";